import Heading from '@components/Heading'
import { File } from '@components/Svg/SVGIcons'
import Text from '@components/Text'
import {
  COLORS,
  HEADING_TYPE,
  TEXT_SIZES,
} from '@helpers/constants'
import React from 'react'

const AttachmentTool = (props) => {
  const { title, preamble, file } = props

  return (
    <div className={'flex'}>
      <div className='mr-2 pt-1 text-primaryGreen'>
        <File />
      </div>

      <div className=''>
        <Heading
          size={TEXT_SIZES.BASE}
          headingLevel={HEADING_TYPE.H3}
          color={COLORS.PRIMARY_GREEN.TEXT}
        >
          {title}
        </Heading>

        <Text>{preamble}</Text>

        <a
          href={file?.url}
          className='mt-2 font-secondary text-sm rounded-full transition-colors inline-flex items-center text-white bg-primaryGreen hover:bg-primaryGreenDark hover:text-white min-h-[34px] px-3.5 focus:outline-none'
          target='_blank'
        >
          Öppna
        </a>
      </div>
    </div>
  )
}

export default AttachmentTool
